export default function stateColor(state) {
  if (state === 'APPROVED') return 'success'
  if (state === 'REJECTED') return 'danger'
  if (state === 'IN_REVIEW') return 'warning'

  console.warn('Wrong state')
  return ''
}
